import { theme } from '@/utils/theme';

export const classes = {
  cell: 'font-normal text-grey-7 text-right',
  expandCell: 'pl-4 pr-1 cursor-pointer',
  expandIcon: 'text-grey-6',
  linkCell: 'text-left',
  link: 'hover:underline text-grey-7 font-semibold cursor-pointer',
  centeredCell: 'flex items-center justify-center',
  percentage: 'text-sm font-semibold ml-2',
  positive: 'text-green-text',
  negative: 'text-red-3',
  price: 'text-sm font-semibold text-grey-6',
};

export const styles = {
  row: (isExpanded: boolean) => ({
    '& td:first-of-type': isExpanded
      ? {
          borderLeft: `1px solid ${theme.palette['grey-3'].main}`,
        }
      : {},
    '& td:last-of-type': isExpanded
      ? {
          borderRight: `1px solid ${theme.palette['grey-3'].main}`,
        }
      : {},
    '& td': isExpanded
      ? {
          borderTop: `1px solid ${theme.palette['grey-3'].main}`,
        }
      : {},
    '& .options-cell *': {
      opacity: 0,
      transition: 'opacity 0.1s',
    },
    '&:hover .options-cell *': {
      opacity: 1,
    },
  }),
};
